import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Document',
  'Due Date',
  'Employee',
  'Department',
  'Location',
  'Manager'
];

const HiringVelocityReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report
        name={t('reports.DOCUMENTS')}
        url='/reports/documents'
      />
    </CompositeReport>
  );
};

export default HiringVelocityReport;
